module.exports = __webpack_public_path__ + "static/media/vegitables_5.e4549df1.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_5.csv
// module id = 635
// module chunks = 0